"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsAssetsModal = DetailsAssetsModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const icons_1 = require("@ant-design/icons");
const DetailsAssetsModal_style_1 = require("./DetailsAssetsModal.style");
const AssetsModalCarousel_1 = require("./AssetsModalCarousel");
function DetailsAssetsModal({ isOpen, assets, initialAssetId, closeModal }) {
    return ((0, jsx_runtime_1.jsx)(DetailsAssetsModal_style_1.StyledModal, { visible: isOpen, destroyOnClose: true, modalRender: () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DetailsAssetsModal_style_1.CloseModalButton, { onClick: closeModal, children: (0, jsx_runtime_1.jsx)(icons_1.CloseOutlined, {}) }), (0, jsx_runtime_1.jsx)(AssetsModalCarousel_1.AssetsModalCarousel, { assets: assets, initialAssetId: initialAssetId, closeModal: closeModal })] })), children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) }));
}
